"use client";

import { useResolvedLinkPreview } from "@/lib/hooks/useResolvedLinkPreview";
import { ThetaShareCard, isDrawableLinkPreview } from "./LinkPreviewCard";

/**
 * The card under a published post, for a link the body merely mentions.
 *
 * This is what the old system got from Discourse's onebox markup and the port
 * does not produce: the new renderer emits a plain anchor, by design — a
 * preview is a crawl result, not a property of the text. So the card is derived
 * at READ time from the link itself, which also means it matches what the
 * author saw in the composer, because both go through the same resolver.
 *
 * Renders NOTHING when the link cannot be previewed, including when the target
 * is a Theta thing this reader may not see. The anchor is still in the body, so
 * they keep the link — they just do not get told what is behind it.
 *
 * IT OWNS ITS OWN TOP MARGIN, so that "nothing" really is nothing. The spacing
 * used to live on a wrapper in `RichContent`, which had no way to know whether
 * a card was coming: when this returned `null` the wrapper stayed and left a
 * stray gap between the body and whatever followed. Pre-existing for
 * `kind: "none"`, and OSO-616's null-for-an-unknown-kind made it reachable for
 * a second reason — so the margin moved to the element that knows.
 */
export function BodyLinkPreview({ url, gapClass }: { url: string; gapClass: string }) {
  const { data } = useResolvedLinkPreview(url);
  if (!data || data.kind === "none") return null;
  if (!isDrawableLinkPreview(data.preview)) return null;
  return (
    <div className={gapClass}>
      <ThetaShareCard preview={data.preview} />
    </div>
  );
}
